import Vue from 'vue'

export default class ZebraPrinter {
  constructor() {
    this.ready = false
    Vue.loadScript('static/vendors/BrowserPrint-3.0.216.min.js')
    .then(() => {
      this.printer = window.BrowserPrint
      this.printer.getDefaultDevice("printer",
        (device) => {
          this.printerDevice = device;
          this.ready = true
        },
        (error) => {
          console.log('error when getting default device')
        })
    })
    .catch(() => {
      console.error('error when getting default ZebraPrinterDevice')
    });
  }
  send (cmd, onSuccess, onError) {
    return new Promise ((resolve, reject) => {
      if (!this.ready) {
        reject('Printer is not ready or connected...')
      }
      this.printerDevice.send(cmd,
        (result) => {
          resolve(result)
        },
        (error) => {
          reject(error)
        })
    })
  }
}
// export const Loops = ['loop_external', 'loop_internal']
   


// WEBPACK FOOTER //
// ./src/core/services/ZebraPrinter.js